import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);
let host = "http://admin.redmoney.in/";
let bhim_base = "http://admin.redmoney.in/";
let aepsurl = "http://retail.redmoney.in/aeps/";
let submplan = "http://submplan.redmoney.in/MPLAN/Services/API.asmx/";

let base_url = host + "Admin/Services/Recharge.asmx/";
let dmr_url = host + "Admin/Services/quickrecharge.asmx/";
let ezpay_url = host + "Admin/Services/EzyPay_Dmr.asmx/";
let instapay_url = host + "Admin/Services/instantpay_dmr.asmx/";
let aepshistory = host + "Admin/Services/instantpay_aeps.asmx/";
let aepspan = host + "Admin/Services/Recharge.asmx/";
let shopping_url = host + "Admin/Services/Shopping.asmx/";
let minkpay = host + "Admin/Services/MinksPay_AEPS.asmx/";
let minkpaydmr = host + "Admin/Services/minkspay_dmr.asmx/";
let paytm_pg = host +"Admin/Services/PaytmPG.asmx/"
let icici_upi = host +"Admin/Services/icici.asmx/"
let mpayapi = "1e5860d73a7aea0636244b97bed7947a";
//let security_key = "kqkSLhPo11N0";
//let security_key = "33ec5081e4544ff03ed6a0400ada3ad9";
let security_key = "NA";
let instapay_key = "NA";
let aeps_key = "NA";
let print_image = require("./assets/logo.png");
//351958105342020
export default new Vuex.Store({
    state: {
        _rprovider: [],
        _ppprovider: [],
        _dthprovider: [],
        _bbprovider: [],
        _eprovider: [],
        _gprovider: [],
        _llprovider: [],
        _wprovider: [],
        _commissions: [],
        _offers: [],
        _user: [],
        _balance: 0,
        _icici_upi: icici_upi,
        _dmr: null,
        _ezpay: null,
        _instapay: null,
        _bhim: true,
        _aepsenable: false,
        _dmrenable: false,
        _ezpayenable: false,
        _instapayenable: false,
        _shoppingenable: true,
        _enablepayout: false,
        _instantpayoutenable: false,
        _aepspayout: false,
        _quickcharge_dmr: false,
        _minkspay: null,
        _minkspayenable: false,
        _isPay2: false,
        _razorConfig: {
            rid: 'NA',
            base: 'NA',
            logo: '',
            name: "NA",
            descripiton:"Load Moneey Amount"
        },
        _enableGetQR: false
    },
    getters: {
        paytm_pg() {
            return paytm_pg;
        },
        quickcharge_dmr(state) {
            return state._quickcharge_dmr;
        },
        minkspayenable(state) {
            return state._minkspayenable;
        },
        razorConfig(state)  {
            return state._razorConfig
        },
        enablepayout(state) {
            return state._enablepayout;
        },
        shoppingenable(state) {
            return state._shoppingenable;
        },
        aepsenable(state) {
            return state._aepsenable;
        },
        dmrenable(state) {
            return state._dmrenable;
        },
        ezpayenable(state) {
            return state._ezpayenable;
        },
        instapayenable(state) {
            return state._instapayenable;
        },
        security() {
            return security_key;
        },
        rprovider(state) {
            return state._rprovider;
        },
        dmr(state) {
            return state._dmr;
        },
        minkpay(state) {
            return state._minkspay;
        },
        ezpay(state) {
            return state._ezpay;
        },
        instapay(state) {
            return state._instapay;
        },
        ppprovider(state) {
            return state._ppprovider;
        },
        dthprovider(state) {
            return state._dthprovider;
        },
        bbprovider(state) {
            return state._bbprovider;
        },
        eprovider(state) {
            return state._eprovider;
        },
        gprovider(state) {
            return state._gprovider;
        },
        llprovider(state) {
            return state._llprovider;
        },
        wprovider(state) {
            return state._wprovider;
        },
        commissions(state) {
            return state._commissions;
        },
        user(state) {
            return state._user;
        },
        balance(state) {
            return state._balance;
        },
        offers(state) {
            return state._offers;
        },
        bhim(state) {
            return state._bhim;
        },
        src(state) {
            return host;
        },
        print_image(state) {
            return print_image;
        },
        aepsurl(state) {
            return aepsurl;
        },
        aepshistory(state) {
            return aepshistory;
        },
        aepspan(state) {
            return aepspan;
        },
        instantpayoutenable(state) {
            return state._instantpayoutenable;
        },
        aepspayout(state) {
            return state._aepspayout;
        },
        isPay2(state) {
            return state._isPay2;
        },
        host() {
            return host;
        },
        enableGetQR(state) {
            return state._enableGetQR
        }
    },
    mutations: {
        setdmr(state, value) {
            state._dmr = value;
        },
        setezpay(state, value) {
            state._ezpay = value;
        },
        setinstapay(state, value) {
            state._instapay = value;
        },
        setrprovider(state, value) {
            state._rprovider = value;
        },
        setppprovider(state, value) {
            state._ppprovider = value;
        },
        setdthprovider(state, value) {
            state._dthprovider = value;
        },
        setbbprovider(state, value) {
            state._bbprovider = value;
        },
        seteprovider(state, value) {
            state._eprovider = value;
        },
        setgprovider(state, value) {
            state._gprovider = value;
        },
        setllprovider(state, value) {
            state._llprovider = value;
        },
        setwprovider(state, value) {
            state._wprovider = value;
        },
        setcommissions(state, value) {
            state._commissions = value;
        },
        setuser(state, value) {
            state._user = value;
        },
        setbalance(state, value) {
            state._balance = value;
        },
        setoffers(state, value) {
            state._offers = value;
        }
    },
    actions: {
        getuser(context) {
            let doc = [];
            if (localStorage.user) {
                doc = JSON.parse(localStorage.user);
            }
            if (doc != null) context.commit("setuser", doc);
        },
        axiosget(context, payload) {
            let url = base_url + payload.url;
            let params = payload.data;
            let way = payload.way;
            return new Promise((resolve, reject) => {
                Vue.axios
                    .get(url, { params: params })
                    .then(function(docs) {
                        resolve(docs);
                        if (docs.data.Message == "Not Authorised.") {
                            window.localStorage.removeItem("user");
                            context.dispatch("getuser");
                            return;
                        }
                        if (way != undefined) {
                            if (docs.data) context.commit(way, docs.data);
                        }
                    })
                    .catch(function(error) {
                        reject(error);
                    });
            });
        },
        axiospost(context, payload) {
            let url = base_url + payload.url;
            let params = payload.data;
            return new Promise((resolve, reject) => {
                Vue.axios
                    .get(url, { params: params })
                    .then(function(docs) {
                        if (docs.data.Message == "Not Authorised.") {
                            window.localStorage.removeItem("user");
                            context.dispatch("getuser");
                            return resolve(docs);
                        }
                        resolve(docs);
                    })
                    .catch(function(error) {
                        reject(error);
                    });
            });
        },
        axiosshop(context, payload) {
            let url = shopping_url + payload.url;
            let params = payload.data;
            return new Promise((resolve, reject) => {
                Vue.axios
                    .get(url, { params: params })
                    .then(function(docs) {
                        if (docs.data.Message == "Not Authorised.") {
                            window.localStorage.removeItem("user");
                            context.dispatch("getuser");
                            return resolve(docs);
                        }
                        resolve(docs);
                    })
                    .catch(function(error) {
                        reject(error);
                    });
            });
        },
        axiosdmrpost(context, payload) {
            let url = dmr_url + payload.url;
            let params = payload.data;
            if (payload.type === "ezpay") {
                url = ezpay_url + payload.url;
                params.Security_Key = security_key;
            }
            if (payload.type === "instapay") {
                url = instapay_url + payload.url;
                params.Security_Key = instapay_key;
            }
            if (payload.type === "aeps") {
                url = aepshistory + payload.url;
                params.Security_Key = aeps_key;
            }
            if (payload.type === "mink") {
                url = minkpay + payload.url;
            }
            if (payload.type === "minkspay") {
                url = minkpaydmr + payload.url;
            }
            return new Promise((resolve, reject) => {
                Vue.axios
                    .get(url, { params: params })
                    .then(function(docs) {
                        if (docs.data.Message == "Not Authorised.") {
                            window.localStorage.removeItem("user");
                            context.dispatch("getuser");
                            return resolve(docs);
                        }
                        resolve(docs);
                    })
                    .catch(function(error) {
                        reject(error);
                    });
            });
        },
        planapi(context, payload) {
            let url = submplan + payload.url;
            let params = {
                url: "apikey=" + mpayapi + "|" + payload.data
            };
            return new Promise((resolve, reject) => {
                Vue.axios
                    .get(url, { params: params })
                    .then(function(docs) {
                        if (docs.data.Message == "Not Authorised.") {
                            window.localStorage.removeItem("user");
                            context.dispatch("getuser");
                            return resolve(docs);
                        }
                        resolve(docs);
                    })
                    .catch(function(error) {
                        reject(error);
                    });
            });
        },
        fetchbill(context, payload) {
            let url = "http://www.oyepe.in/ReCharge/CyberPlatBBPS.asmx/BillFatch";
            let params = payload.data;
            return new Promise((resolve, reject) => {
                Vue.axios
                    .get(url, { params: params })
                    .then(function(docs) {
                        if (docs.data.Message == "Not Authorised.") {
                            window.localStorage.removeItem("user");
                            context.dispatch("getuser");
                            return resolve(docs);
                        }
                        resolve(docs);
                    })
                    .catch(function(error) {
                        reject(error);
                    });
            });
        },
        fetchbhimbill(context, payload) {
            let url = bhim_base + "Admin/Services/EzyPay_BillService.asmx/BillFetch";
            let params = payload.data;
            params.Security_Key = "jkehfuewui58473rklrke9854";

            return new Promise((resolve, reject) => {
                Vue.axios
                    .get(url, { params: params })
                    .then(function(docs) {
                        if (docs.data.Message == "Not Authorised.") {
                            window.localStorage.removeItem("user");
                            context.dispatch("getuser");
                            return resolve(docs);
                        }
                        resolve(docs);
                    })
                    .catch(function(error) {
                        reject(error);
                    });
            });
        },
        getbalance(context) {
            let user = context.getters.user;
            let doc = {
                MobileNo: user.phone,
                Password: user.password,
                AuthKey: user.authkey,
                Source: "json"
            };
            let url = base_url + "BalUpdate";
            return new Promise((resolve, reject) => {
                Vue.axios
                    .get(url, { params: doc })
                    .then(function(docs) {
                        if (docs.data.Message == "Not Authorised.") {
                            window.localStorage.removeItem("user");
                            context.dispatch("getuser");
                            return resolve(docs);
                        }
                        if (docs.data.Data)
                            context.commit("setbalance", docs.data.Data.Balance);
                    })
                    .catch(function(error) {
                        console.log(error);

                        reject(error);
                    });
            });
        },
        showdetails(context, payload) {
            return new Promise((resolve, reject) => {
                let result = payload.data;
                let temp = JSON.stringify(result);
                temp = temp.replace('{"d":null}', " ");
                let json = JSON.parse(temp);
                if (json.Message.includes("<") && json.Message.includes(">")) {
                    json.Message = json.Message.replace(/</gi, "").replace(/>/g, ",");
                    let fields = json.Message.split(",");
                    let cname = fields[6].split("!");
                    if (fields[5].trim() == "N") {
                        fields[5] = "NO";
                    } else {
                        fields[5] = "YES";
                    }
                    let summary = {
                        "Customer Name": cname[1],
                        "Service No": fields[1].trim(),
                        Amount: fields[0],
                        "Bill Generate Date": fields[2].trim(),
                        "Bill Due Date": fields[3].trim(),
                        "Partial Payment": fields[5].trim()
                    };
                    resolve(summary);
                } else {
                    reject(json.Message);
                }
            });
        }
    }
});

